// 章节草稿快照（IndexedDB）：
// 编辑器内每 8 秒 + 页面隐藏/关闭前落盘，崩溃或误关后可恢复未保存内容。
// 与"章节版本"的区别：版本是保存动作产生的留档，草稿是编辑过程的秒级快照。

const DB_NAME = 'xiaotianshu-drafts';
const STORE = 'chapter_drafts';
const VERSION = 1;

export interface ChapterDraft {
  chapterId: string;
  bookId: string;
  title: string;
  content: string; // HTML 内容（TipTap 格式）
  savedAt: number;
}

let dbPromise: Promise<IDBDatabase> | null = null;

function openDb(): Promise<IDBDatabase> {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: 'chapterId' });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
}

export async function saveChapterDraft(draft: ChapterDraft): Promise<void> {
  try {
    const db = await openDb();
    await new Promise<void>((resolve, reject) => {
      const tx = db.transaction(STORE, 'readwrite');
      tx.objectStore(STORE).put(draft);
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
    });
  } catch { /* IndexedDB 不可用时静默降级 */ }
}

export async function getChapterDraft(chapterId: string): Promise<ChapterDraft | null> {
  try {
    const db = await openDb();
    return await new Promise<ChapterDraft | null>((resolve, reject) => {
      const req = db.transaction(STORE, 'readonly').objectStore(STORE).get(chapterId);
      req.onsuccess = () => resolve((req.result as ChapterDraft | undefined) ?? null);
      req.onerror = () => reject(req.error);
    });
  } catch {
    return null;
  }
}

export async function clearChapterDraft(chapterId: string): Promise<void> {
  try {
    const db = await openDb();
    await new Promise<void>((resolve, reject) => {
      const tx = db.transaction(STORE, 'readwrite');
      tx.objectStore(STORE).delete(chapterId);
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
    });
  } catch { /* ignore */ }
}
